<template>
	<el-scrollbar style="height: 100%">
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/gardenList' }">
					<i class="el-icon-school"></i> 幼儿园管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新预存款</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" >
				<el-row style="margin-top: 20px;">
					<el-col :span="6">
					<el-form-item :label="''" label-width="200px">	
					</el-form-item>
					</el-col>
				  <el-col :span="12">
					<el-form-item :label="'幼儿园名称'" prop="saaName"label-width="230px">
						<el-input v-model="ruleForm.saaName" :placeholder="'请输入幼儿园名称'":disabled="true">></el-input>
					</el-form-item>
				  </el-col>
				 </el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item :label="''"label-width="200px">					
						</el-form-item>
					</el-col>
				  <el-col :span="7">
					<el-form-item :label="'线上付款平台应收金额'" label-width="200px">	
					</el-form-item>
				  </el-col>
				  <el-col :span="6">
				  		<el-form-item :label="'代缴金额'"label-width="130px">				
				  		</el-form-item>
				  </el-col>
				 </el-row>
				  <el-row>
				 <el-col :span="13">
				 	<el-form-item :label="'30天'"  prop="sbbJKFY21" label-width="340px">
				 	<!-- <el-input v-model.number="ruleForm.sbbJKFY21" oninput="if(value.length>7)value=value.slice(0,7)"  :min="0"  type="number" :placeholder="'请输入视频费用'"></el-input> -->
				 	<el-input v-model="ruleForm.sbbJKFY21" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>
				 </el-col>
				 <el-col :span="7">
					<el-form-item :label="''"  prop="sbbJKFY31" label-width="20px">
				 	<el-input v-model="ruleForm.sbbJKFY31"  clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
				    </el-form-item>
				 </el-col>
				 </el-row>
				<el-row>
				<el-col :span="13">
					<el-form-item :label="'60天'" prop="sbbJKFY22" label-width="340px">
					<el-input v-model="ruleForm.sbbJKFY22" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item :label="''"  prop="sbbJKFY32" label-width="20px">	
					<el-input v-model="ruleForm.sbbJKFY32" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>			
				</el-col>
				
				</el-row>
				<el-row>
				<el-col :span="13">
					<el-form-item :label="'90天'" prop="sbbJKFY23" label-width="340px">
					<el-input v-model="ruleForm.sbbJKFY23" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item :label="''"   prop="sbbJKFY33" label-width="20px">
						<el-input v-model="ruleForm.sbbJKFY33" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>		
					</el-form-item>			
				</el-col>
				</el-row>
				<el-row>
				<el-col :span="13">
					<el-form-item :label="'180天'" prop="sbbJKFY24" label-width="340px">
					<el-input v-model="ruleForm.sbbJKFY24" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item :label="''"   prop="sbbJKFY34" label-width="20px">
						<el-input v-model="ruleForm.sbbJKFY34" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>			
					</el-form-item>			
				</el-col>
				</el-row>
				<el-row>
				<el-col :span="13">
					<el-form-item :label="'360天'" prop="sbbJKFY25" label-width="340px">
					<el-input v-model="ruleForm.sbbJKFY25" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item :label="''"   prop="sbbJKFY35" label-width="20px">
						<el-input v-model="ruleForm.sbbJKFY35" clearable oninput="value=value.replace(/[^0-9.]/g,'');if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入视频费用'"></el-input>		
					</el-form-item>			
				</el-col>
				</el-row>
				<el-row>
					<el-col :span="18">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
								
							</el-form-item>
						</div>
					</el-col>
				</el-row>	
			</el-form>
			
			<el-form :model="ruleForm2" :rules="rules" ref="ruleForm2" label-width="180px">
				<el-row style="margin-top: 20px;">	
				<el-col :span="14">
					<el-form-item :label="'金额调整'" prop="spaPOIT" label-width="360px">
					<el-input  v-model="ruleForm2.spaPOIT" clearable oninput="if(value.length>8)value=value.slice(0,8)" :placeholder="'请输入金额'"></el-input>
					<span style=" width:150%; height: 10px; padding-top: 10px; font-size: 14px;color: #999999;">
						调节增减预付款，只能输入数字，可输入负数，（例原存款100元，输入-50，确认后余额为50元）
					</span>
					</el-form-item>
                </el-col>
                </el-row>
				<el-row>
				<el-col :span="14">
					<el-form-item :label="'现存金额'" prop="saaYCJE" label-width="360px">
					<el-input v-model="ruleForm2.saaYCJE" :disabled="true" oninput="if(value.length>8)value=value.slice(0,8)"></el-input>
					</el-form-item>		
				</el-col>
				</el-row>
				<el-row>
					<el-col :span="18">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm2('ruleForm2')">保存</el-button>
								
							</el-form-item>
						</div>
					</el-col>
				</el-row>	
			</el-form>
		</div>
	</div>
	</el-scrollbar>
</template>

<script>
	export default {
		name: 'editSAAYCJE',
		inject: ['reload'],
		data() {
			 const validateMoney = (rule,value,callback) =>{
			        if(!value){
			            callback(new Error('请输入视频费用，仅限两位小数'))
			         }else if(value.indexOf(".") != -1 && value.split('.').length > 2){
			            callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
			         }else if(value.indexOf(".") != -1 && value.split('.')[1].length > 2){
			           callback(new Error('仅限两位小数')) //小数点后两位
					 }else if(value.indexOf(".") == -1 && value.length > 5){
					     callback(new Error('请输入五位整数,最多保留两位小数')) 
			        }else{
			          callback();
			        }
			    }
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				sbbChangeData: {},
				dataYCJE:{},
				ruleForm: {
					sbbSAAI: '',
					saaName: '',
					sbbJKFY21:'0',
					sbbJKFY31:'0',
					sbbJKFY22:'0',
					sbbJKFY32:'0',
					sbbJKFY23:'0',
					sbbJKFY33:'0',
					sbbJKFY24:'0',
					sbbJKFY34:'0',
					sbbJKFY25:'0',
					sbbJKFY35:'0'
				},
				ruleForm2: {
					sbbSAAI: '',
					spaPOIT:'0',
					saaYCJE:'0'
				},
				rules: {
					sbbJKFY21: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					
					sbbJKFY31: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY22: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY32: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY23: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY33: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY24: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY34: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY25: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					sbbJKFY35: [{
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
					}],
					spaPOIT:[
						{ 
						required: true,
						
						trigger: ['blur', 'change'],
						validator:validateMoney
						}
					]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editSAAYCJE") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.sbbSAAI = this.$route.query.SAAMSID;
			
			this.getData(this.sbbSAAI);
			this.getYCJE(this.sbbSAAI);	
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			dummyCreated () {
				this.sbbSAAI = this.$route.query.SAAMSID;
				
				this.getData(this.sbbSAAI);
				this.getYCJE(this.sbbSAAI);
			},
			//获取视频费用信息
			getData(sbbSAAI) {
				const self = this;
				var postUrl = 'WCF/WEB/svcSBB.svc/GET_SBB_BYID';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, 
							sMSID: sbbSAAI //会社ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
							self.ruleForm.saaName = response.data.KKDT[0].SAANAME;
							for (let i = 0; i < resCount; i++) {
								if (response.data.KKDT[i].SBBSTAT == "2" ) {
									if(response.data.KKDT[i].SBBJKLX == "1"){
										self.ruleForm.sbbJKFY21 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "2"){
									    self.ruleForm.sbbJKFY22 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "3"){
									    self.ruleForm.sbbJKFY23 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "4"){
									    self.ruleForm.sbbJKFY24 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "5"){
									    self.ruleForm.sbbJKFY25 = response.data.KKDT[i].SBBJKFY;
									}
								}
								if (response.data.KKDT[i].SBBSTAT == "3" ) {
									if(response.data.KKDT[i].SBBJKLX == "1"){
										self.ruleForm.sbbJKFY31 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "2"){
									    self.ruleForm.sbbJKFY32 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "3"){
									    self.ruleForm.sbbJKFY33 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "4"){
									    self.ruleForm.sbbJKFY34 = response.data.KKDT[i].SBBJKFY;
									}else if (response.data.KKDT[i].SBBJKLX == "5"){
									    self.ruleForm.sbbJKFY35 = response.data.KKDT[i].SBBJKFY;
									}
								}
							}
								
							this.sbbChangeData = response.data.KKDT[0];
							
							} 
							else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} 
						else {
							this.$message({
								message: '请求获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//获取现存金额信息
			getYCJE(sbbSAAI) {
				const self = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/GET_SAA_BYID';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, 
							sMSID: sbbSAAI //会社ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
							self.ruleForm2.saaYCJE = response.data.KKDT[0].SAAYCJE;
							this.dataYCJE = response.data.KKDT[0];
							}
							else {
								this.$message({
									message: '获取现存金额失败', //无数据
									type: 'error'
								});
							}
						 }
						 else {
							this.$message({
								message: '请求获取现存金额失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取现存金额失败', //请求失败
							type: 'error'
						});
					});
			},
			//更新视频费用
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
					
					const self = this;
					if (Number(self.ruleForm.sbbJKFY21)<Number(self.ruleForm.sbbJKFY31)){
						this.$message({
							message: ' 30天 [ 线上付款平台应收金额 ] 不能小于 [ 代缴金额 ]', 
							type: 'error'
						});
						return false;
					};
					if (Number(self.ruleForm.sbbJKFY22)<Number(self.ruleForm.sbbJKFY32)){
						this.$message({
							message: ' 60天 [ 线上付款平台应收金额 ] 不能小于 [ 代缴金额 ]', 
							type: 'error'
						});
						return false;
					};
					if (Number(self.ruleForm.sbbJKFY23)<Number(self.ruleForm.sbbJKFY33)){
						this.$message({
							message: ' 90天 [ 线上付款平台应收金额 ] 不能小于 [ 代缴金额 ]', 
							type: 'error'
						});
						return false;
					};
					if (Number(self.ruleForm.sbbJKFY24)<Number(self.ruleForm.sbbJKFY34)){
						this.$message({
							message: ' 180天 [ 线上付款平台应收金额 ] 不能小于 [ 代缴金额 ]', 
							type: 'error'
						});
						return false;
					};
					if (Number(self.ruleForm.sbbJKFY25)<Number(self.ruleForm.sbbJKFY35)){
						this.$message({
							message: ' 360天 [ 线上付款平台应收金额 ] 不能小于 [ 代缴金额 ]', 
							type: 'error'
						});
						return false;
					};
					
					this.$confirm('确认要提交吗？', '提示', {
					      confirmButtonText: '确定',
					      cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {
							
							var postUrl = 'WCF/WEB/svcSBB.svc/UPD_SBB_BYID';
							
							let jkfyArr = [];
							jkfyArr.push(self.ruleForm.sbbJKFY21);
							jkfyArr.push(self.ruleForm.sbbJKFY22);
							jkfyArr.push(self.ruleForm.sbbJKFY23);
							jkfyArr.push(self.ruleForm.sbbJKFY24);
							jkfyArr.push(self.ruleForm.sbbJKFY25);
							jkfyArr.push(self.ruleForm.sbbJKFY31);
							jkfyArr.push(self.ruleForm.sbbJKFY32);
							jkfyArr.push(self.ruleForm.sbbJKFY33);
							jkfyArr.push(self.ruleForm.sbbJKFY34);
							jkfyArr.push(self.ruleForm.sbbJKFY35);
							
							//网络请求接口
							this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sSBBSAAI: self.sbbChangeData.SAAMSID,
									sSBBJKFY: jkfyArr
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
			
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '视频费用更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('视频费用更新成功'); // 编辑成功
										this.getYCJE(this.dataYCJE.SAAMSID);
									}
								} else {
									this.$message({
										message: '请求更新视频费用失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新视频费用失败', //请求失败
									type: 'error'
								});
							});
						})
						
					} else {
						this.$message({
							message: '视频费用更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			//保存预存款履历
			submitForm2(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {

						const self = this;
						if (self.ruleForm2.spaPOIT==0){
							this.$message({
								message: '请输入有效金额', 
								type: 'error'
							});
							return false;
						};
						
						this.$confirm('确认要提交吗？', '提示', {
						      confirmButtonText: '确定',
						      cancelButtonText: '取消',
								type: 'warning'
							})
							.then(() => {

								var postUrl = 'WCF/WEB/svcSPA.svc/ADD_SPA';
								//网络请求接口
								this.$axios.post(
									//请求的url
									postUrl,
									//请求参数
									{
										sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
										sSPAPOIT: self.ruleForm2.spaPOIT,
										sSPABFPT: self.ruleForm2.saaYCJE,
										sSPASAAI: this.dataYCJE.SAAMSID
									}
								)
								.then((response) => {
									//请求成功返回的数据
									let resStatus = response.status; //200 代表请求成功
									let resKKSTR = response.data.KKSTR;

									if (resStatus == "200") {
										if (resKKSTR == "N") {
											this.$message({
												message: '现存金额更新失败', //编辑失败
												type: 'error'
											});
										} else if (resKKSTR == "Y") {
											this.$message.success('现存金额更新成功'); // 编辑成功
											this.getYCJE(this.dataYCJE.SAAMSID);
										}
									} else {
										this.$message({
											message: '请求更新现存金额失败', //请求失败
											type: 'error'
										});
									}
								})
								.catch((error) => {
									this.$message({
										message: '请求更新现存金额失败', //请求失败
										type: 'error'
									});
								});
							})
					} else {
						this.$message({
							message: '现存金额更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editSAAYCJE") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			},
			
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			
		}
	}
</script>
<style scoped>
	.el-dialog__footer {
		text-align: center;
	}
	
	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	
	
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 60%;
	}
    .el-form {
	   border: 0.1cm groove skyblue;
	   margin-top: 10px;
	}
	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}
</style>
